document.addEventListener("DOMContentLoaded", () => {

    const variantRadios = document.querySelector("variant-radios");

    if (!variantRadios) return;

    document.querySelectorAll(".variant-card").forEach(card => {

        card.addEventListener("click", () => {

            document.querySelectorAll(".variant-card")
                .forEach(c => c.classList.remove("active"));

            card.classList.add("active");

            card.querySelector(".variant-card-input").checked = true;

            const option = card.dataset.option;

            const nativeRadio = variantRadios.querySelector(
                `input[value="${option}"]`
            );

            if (!nativeRadio) {
                console.log("Native radio not found", option);
                return;
            }

            nativeRadio.checked = true;

            nativeRadio.dispatchEvent(
                new Event("change", { bubbles: true })
            );

        });

    });

});